import {GraphQLResolveInfo} from "graphql";

export default (resolve, parent, args, context, info: GraphQLResolveInfo) => {
    if (!context.locale) {
        context.locale = context.request.locale;
    }
    return resolve(parent, args, context, info);
}
